export default __webpack_public_path__ + "2898e5df6c55cf035ee9c70077932694.svg";